<!--  -->
<template>
  <div class="vab-avatar">
    <a-dropdown :trigger="['click']">
      <span class="ant-dropdown-link">
        <a-avatar :src="avatar" />
        <!-- {{ username }} -->
        <span class="ant-span">{{userName}}</span>
        <DownOutlined />
      </span>
      <template v-slot:overlay>
        <form ref="logoutForm" :action="logoutURI" method="post">
          <a-menu class="avatar">
            <a-menu-item @click="logoutChange">退出登录</a-menu-item>
          </a-menu>
        </form>
      </template>
    </a-dropdown>
  </div>
</template>

<script>
// 导入的其他文件 例如：import moduleName from 'modulePath';
import { DownOutlined } from "@ant-design/icons-vue";
import { useRouter } from "vue-router";
import { ref, reactive, toRefs, watchEffect } from "vue";
import { useStore } from "vuex";
export default {
  props: ["avatar"],
  components: {
    DownOutlined
  },
  setup() {
    let logoutForm = ref(null);
    const logoutURI = "/auth/logout";
    let store = useStore();
    const state = reactive({
      userName: ""
    });
    watchEffect(() => {
      if (store.state.settings.userInfo) {
        state.userName = store.state.settings.userInfo.fullname;
      }
    });
    return {
      logoutForm,
      logoutURI,
      ...toRefs(state)
    };
  },
  methods: {
    logoutChange() {
      this.$refs.logoutForm.submit();
    }
  }
};
</script>
<style lang="less">
.avatar .ant-menu-item {
  #flex-box.row-c-c();
}
</style>
<style lang='less' scoped>
.vab-avatar {
  .ant-dropdown-link {
    display: block;
    min-height: 64px;
    cursor: pointer;
  }
}
.ant-span {
  padding: 0 20px;
  font-weight: bold;
}
</style>